


































import { defineComponent, PropType } from "@vue/composition-api";
import ListTable, {
  Props as ListTableProps
} from "@/components/Molecules/ListTable/index.vue";
import VideoBundleUnlockingLogsTableCell from "../Molecule/VideoBundleUnlockingLogsTableCell.vue";
import { ApiResponse, ApiRequest } from "@/api/types";
import { formatUnlockedAt } from "@/helpers/videoBundleUnlockingLogs";

export default defineComponent({
  name: "VideoBundleUnlockingLogsTable",
  components: {
    ListTable,
    VideoBundleUnlockingLogsTableCell
  },
  props: {
    headers: {
      type: Array as PropType<ListTableProps["headers"]>,
      default: () => []
    },
    videoBundleUnlockingLogs: {
      type: Array as PropType<ApiResponse.VideoBundleUnlockingLog[]>,
      default: () => []
    },
    onChangeOrder: {
      type: Function as PropType<
        (
          order: ApiRequest.VideoBundleUnlockingLogs["order"],
          headerIndex: number
        ) => void
      >,
      default: () => {}
    }
  },
  setup() {
    function userName(
      VideoBundleUnlockingLog: ApiResponse.VideoBundleUnlockingLog
    ) {
      const {
        last_name: lastName,
        first_name: firstName
      } = VideoBundleUnlockingLog.user;

      if (!lastName && !firstName) return "未登録";

      return [lastName, firstName].join(" ");
    }

    function userNameKana(
      VideoBundleUnlockingLog: ApiResponse.VideoBundleUnlockingLog
    ) {
      const {
        last_name_kana: lastNameKana,
        first_name_kana: firstNameKana
      } = VideoBundleUnlockingLog.user;

      if (!lastNameKana && !firstNameKana) return "未登録";

      return [lastNameKana, firstNameKana].join(" ");
    }

    function userUniversityName(
      VideoBundleUnlockingLog: ApiResponse.VideoBundleUnlockingLog
    ) {
      const { university_name: universityName } = VideoBundleUnlockingLog.user;

      return universityName || "未登録";
    }

    function userGraduateYear(
      VideoBundleUnlockingLog: ApiResponse.VideoBundleUnlockingLog
    ) {
      const { graduate_year: graduateYear } = VideoBundleUnlockingLog.user;

      return graduateYear || "未登録";
    }

    function userDepartmentGradeName(
      VideoBundleUnlockingLog: ApiResponse.VideoBundleUnlockingLog
    ) {
      const {
        department_name: departmentName,
        grade
      } = VideoBundleUnlockingLog.user;

      if (!departmentName && !grade) return "未登録";

      return [departmentName, grade].join(" ");
    }

    return {
      userName,
      userNameKana,
      userUniversityName,
      userGraduateYear,
      userDepartmentGradeName,
      formatUnlockedAt
    };
  }
});
